import { useField } from 'formik'

import { Checkbox } from '~/components/checkbox'
import { Field } from '~/components/field'

type Props = {
  name: string
  label: string
  options: string[]
  optional?: boolean
}

export const CustomFieldCheckboxGroup = ({
  name,
  label,
  options,
  optional,
}: Props) => {
  const [field, meta, helpers] = useField<string[]>({ name })
  const selected = field.value ?? []

  const toggle = (option: string) => {
    const next = new Set(selected)

    if (next.has(option)) {
      next.delete(option)
    } else {
      next.add(option)
    }

    // Rebuild from the option list, so the answer follows the order of the
    // field definition rather than the order the donor ticked the boxes.
    helpers.setValue(options.filter(item => next.has(item)))
    // Formik validates setTouched against the value of the current render, so
    // a validating call here would report the answer the donor just replaced.
    helpers.setTouched(true, false)
  }

  return (
    <Field
      label={label}
      name={name}
      optional={optional}
      error={meta.touched && meta.error ? meta.error : undefined}
    >
      <div className="grid gap-2" role="group" aria-label={label}>
        {options.map(option => (
          <Checkbox
            key={option}
            label={option}
            checked={selected.includes(option)}
            onChange={() => toggle(option)}
          />
        ))}
      </div>
    </Field>
  )
}
